/**
 * Created by valdo on 3/02/17.
 */
export class DriversModel {

  public tabletid: number;
  public hassignature: boolean;
  public signaturephoto: string;
  public hacklicence: string;
  public pin: number;
  public ssn: string;
  public streetaddress: string;
  public roomaptnumber: string;
  public city: string;
  public state: string;
  public zip: string;
  public latitude: number;
  public longitude: number;
  public gender: string;
  public profilephoto: string;
  public driverlicense: string;
  public driverlicencephoto: string;
  public licenseexpiryformatted: string;
  public licenseexpiry: string | null;
  public dobformatted: string;
  public dob: string;
  public licencestate: string;
  public lastappusageformatted: string;
  public photo: string;
  public onroute: boolean;
  public companyid: number;
  public userprofileid: number;
  public fullname: string;
  public firstname: string;
  public middleinitial: string;
  public lastname: string;
  public phone: string;
  public emailaddress: string;
  public isactive: boolean;
  public startdate: any;
  public providerdriverstatusid: number;
  public licensestate?: number | string;
  public homephonenumber: string;
  public referencecode: string;
  public starttime: string;
  public endtime: string;
  public sunday: boolean;
  public monday = true;
  public tuesday = true;
  public wednesday = true;
  public thursday = true;
  public friday = true;
  public saturday = true;
  public starttimemonday: string;
  public starttimetuesday: string;
  public starttimewednesday: string;
  public starttimethursday: string;
  public starttimefriday: string;
  public starttimesaturday: string;
  public starttimesunday: string;
  public endtimemonday: string;
  public endtimetuesday: string;
  public endtimewednesday: string;
  public endtimethursday: string;
  public endtimefriday: string;
  public endtimesaturday: string;
  public endtimesunday: string;
  public paidtimeoff: boolean;
  public ptofromdate: string;
  public ptoenddate: string;
  public ptofromdateformat: string;
  public ptoenddateformat: string;
  public zoneid: number;
  public depotid: number = null;
  public driverid: number;
  public inactivateReason?: string;
  public isemscribeuser?: boolean;
  public islicensevalid: boolean;
  public driverlicensestatusid: number | null;
  public driverlicensestatus?: DriverLicenseStatusModel;
  public mctdriverlicenses: any[];
  public employeeid: string | null = null;
  public emergencycontactname: string | null = null;
  public emergencycontactphone: string | null = null;
  public raceid: number | null = null;
  public employeeclass: number | null = null;
  public terminationdate: string | null = null;
}

export class DriverLicenseStatusModel {
  public driverlicensestatusid: number;
  public speedcode: string;
  public description: string;
  public longdescription: string;
  public isvalid: boolean;

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/pages/drivers/drivers.model.ts